export const createTimeLine = (fromTime, toTime, interval) => {
  const minutes = (toTime - fromTime) / 1000 / 60
  const start = fromTime
  const timeline = []
  const iterations = Math.ceil(minutes / interval)

  for (let i = 0; i <= iterations; i++) { // eslint-disable-line
    if (i !== 0) {
      start.setMinutes(start.getMinutes() + interval)
    }
    timeline.push(start.toString())
  }
  return timeline
}

export const leadingZero = i => (i < 10 ? `0${i}` : i)
export const formatTime = time => `${leadingZero(time.getHours())}:${leadingZero(time.getMinutes())}`
